export class SonyBraviaIr {
    constructor(socket, log) {
        this.socket = socket;
        this.irMode = 'IR';
        this.asyncHandlers = [
            {
                name: 'anyIrCommand',
                regExp: /sendir,(\d+):(\d+),(\d+),.+/i,
                callback: (match) => {
                    this.socket.send(`completeir,${match[1]}:${match[2]},${match[3]}`);
                },
            },
            {
                name: 'ping',
                regExp: /ping/i,
                callback: (match) => {
                    this.socket.send(`ERR_0:0,001`);
                },
            },
            {
                name: 'setIr',
                regExp: /set_IR,(\d+):(\d+),(.+)/i,
                callback: (match) => {
                    if (match[3])
                        this.irMode = match[3];
                    this.socket.send(`IR,${match[1]}:${match[2]},${match[3]}`);
                },
            },
            {
                name: 'getIr',
                regExp: /get_IR,(\d+):(\d+)/i,
                callback: (match) => {
                    this.socket.send(`IR,${match[1]}:${match[2]},${this.irMode}`);
                },
            },
            {
                name: 'stopIr',
                regExp: /stopir,(\d+):(\d+)/i,
                callback: (match) => {
                    this.socket.send(`stopir,${match[1]}:${match[2]}`);
                },
            },
        ];
    }
}
SonyBraviaIr.emulatorType = 'socketEmulator';
SonyBraviaIr.key = '-LwF24xYwxN9YDfZ7c9c';
